import { render, staticRenderFns } from "./Modifications.vue?vue&type=template&id=4c1858b8&"
import script from "./Modifications.vue?vue&type=script&lang=js&"
export * from "./Modifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports